import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/style.css';
import { getData } from '../Data/Project/GetData';


const Carousel = () => {
  React.useEffect(() => {
    // Initialize Owl Carousel when the component mounts
    const $ = window.$; // Assuming jQuery is globally available
    $('.featured-carousel').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      items: 1,
      autoplay: true,
      autoplayTimeout: 2000,
      autoplayHoverPause: true
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Shital Paints</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <link href="https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,800,900" rel="stylesheet" />
        <link href="https://fonts.googleapis.com/css?family=Playfair+Display:400,400i,700,700i&display=swap" rel="stylesheet" />
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/ionicons/4.5.6/css/ionicons.min.css" />
      </Helmet>
      <section className="ftco-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2
                className="heading-section mb-5"
                style={{
                  color: 'black',
                  fontFamily: `'Playfair Display', serif`,
                  fontSize: '2.5rem',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  letterSpacing: '2px',
                  borderBottom: '3px solid var(--primary-color)',
                  display: 'inline-block',
                  paddingBottom: '10px',
                  marginBottom: '20px',
                  position: 'relative',
                }}
              >
                Projects
              </h2>
            </div>

            <div className="col-md-12">
              <div className="featured-carousel owl-carousel">
                {getData.map((item, index) => (
                  <div key={index} className="item">
                    <div className="row justify-content-center">
                      <div className="col-md-11">
                        <div className="testimony-wrap d-md-flex">
                          <div className="img" style={{ backgroundImage: `url(${(`/Images/Project/${item.imageURL}`)})` }}></div>
                          <div className="text text-center p-4 py-xl-5 px-xl-5 d-flex align-items-center">
                            <div className="desc w-100">
                              <p className="h3 mb-5">{item.Title}</p>
                              <div className="pt-4">
                                <p className="name mb-0">{item.Desc}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Carousel;